import axios from "axios";

import { SraDepartmentListModel, SraDepartmentDetailModel, SraDepartmentCreateModel, SraDepartmentEditModel } from "./model";

class SraDepartmentApi {

    private readonly sraCustomerApiUrl = "/api/sracustomer";
    private readonly sraDepartmentApiUrl = "sradepartment";

    public async getAll(sraCustomerId: string): Promise<SraDepartmentListModel[]> {
        const response = await axios.get(`${this.sraCustomerApiUrl}/${sraCustomerId}/${this.sraDepartmentApiUrl}`);
        const data = response.data as SraDepartmentListModel[];
        return data.map(this.parseModel);
    }

    public async detail(sraCustomerId: string, id: string): Promise<SraDepartmentDetailModel> {
        const response = await axios.get(`${this.sraCustomerApiUrl}/${sraCustomerId}/${this.sraDepartmentApiUrl}/${id}`);
        const model = response.data as SraDepartmentDetailModel;
        return this.parseModel(model);
    }

    public async save(sraCustomerId: string, sraDepartment: SraDepartmentEditModel): Promise<SraDepartmentDetailModel> {
        const response = await axios.put(`${this.sraCustomerApiUrl}/${sraCustomerId}/${this.sraDepartmentApiUrl}/${sraDepartment.id}`, sraDepartment);
        const model = response.data as SraDepartmentDetailModel;
        return this.parseModel(model);
    }

    public async create(sraCustomerId: string, sraDepartment: SraDepartmentCreateModel): Promise<SraDepartmentDetailModel> {
        const response = await axios.post(`${this.sraCustomerApiUrl}/${sraCustomerId}/${this.sraDepartmentApiUrl}`, sraDepartment);
        const model = response.data as SraDepartmentDetailModel;
        return this.parseModel(model);
    }

    public delete(sraCustomerId: string, id: string): Promise<any> {
        return axios.delete(`${this.sraCustomerApiUrl}/${sraCustomerId}/${this.sraDepartmentApiUrl}/${id}`);
    }

    public parseModel(model: SraDepartmentDetailModel): SraDepartmentDetailModel {
        return {
            ...model
        };
    }
}

export const sraDepartmentApi = new SraDepartmentApi();
